import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { PersonaDetailDto } from '@models/personas/personaDetailDto.model';
import { UnlockPersonaRequest } from '@models/personas/unlockPersonaRequest.model';
import { UpdatePersonaRequest } from '@models/personas/updatePersonaRequest.model';
import { PersonasService } from '@services/personas/personas.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-form-persona-reactive',
  templateUrl: './form-persona-reactive.component.html',
  styleUrls: ['./form-persona-reactive.component.css']
})
export class FormPersonaReactiveComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<FormPersonaReactiveComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: PersonaDetailDto,
    private personasService: PersonasService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService

  ) { }

  ngOnInit(): void {
  }

  reactivar(personaDetailDto: PersonaDetailDto): void {
    this.spinner.show("spPersona");
    let unlockPersonaRequest = new UnlockPersonaRequest
    unlockPersonaRequest.id_Persona = personaDetailDto.id
    this.personasService.unlockPersona(unlockPersonaRequest)
      .subscribe(data => {
        if (data = true) {
          this.spinner.hide("spPersona");
          this.snackBar.showSuccess("Se activó la persona de manera correcta.", "Exito")
          this.dialogRef.close({ event: AccionesDialog.Eliminar });
        }
      },
        error => {
          this.spinner.hide("spPersona");
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar });
        }
      )
  }
  onNoClick(): void {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

}
